
export const definitionDictionary = {
    ALC: {        
        definition: 'alcohol.html'        
    },
    ART: {
        definition: 'arthritis.html'
    },    
    AST: {
        definition: 'asthma.html'
    },
    CAN: {
        definition: 'cancer.html'
    },
    CHC: {
        definition:'cognitive-health-caregiving.html'
    },
    CVD: {
        definition: 'cardiovascular-disease.html'
    },
    CKD: {
        definition: 'chronic-kidney-disease.html'
    },
    COPD: {
        definition: 'chronic-obstructive-pulmonary-disease.html'
    },
    DIA: {
        definition: 'diabetes.html'
    },
    DIS: {
        definition: 'disability.html'
    },
    HEA: {
        definition: 'health-status.html'
    },
    IMM: {
        definition: 'immunization.html'
    },
    MAT: {
        definition: 'maternal-health.html'
    },
    MEN: {
        definition: 'mental-health.html'
    },
    NPAW: {
        definition: 'npao.html'
    },
    OLD: {
        definition: 'older-adults.html'
    },
    ORH: {
        definition: 'oral-health.html'
    },
    OVC: {
        definition: 'overarching-conditions.html'
    },
    RPH: {
        definition: 'reproductive-health.html'
    },
    SLEP: {
        definition: 'sleep.html'
    },
    SDOH: {
        definition:'sdoh.html'
    },
    STH: {
        definition:'student-health.html'
    },
    TOB: {
        definition: 'tobacco.html'
    },
};

